import { useEffect, useState } from "react";
import { Card, CardHeader, Col } from "reactstrap";
import { H4, P } from "../../../../AbstractElements";
import TotalParikamiCardBody from "./TotalParikamiCardBody";
// import _axios from "axios";
import { ServerPath } from "../../../../Constant";
import { _axios } from "../../../../utils/axios";

const TotalParikami = () => {
    const [count, setCount] = useState("--");

    useEffect(() => {
        const fetchCount = async () => {
            try {
                const response = await _axios.get(`${ServerPath}/users/count`);
                console.log('response', response.data);
                if (response.data.success) {
                    setCount(response.data.data.total.toLocaleString());
                }
            } catch (error) {
                console.error("Error fetching parikamis count:", error);
            }
        };
        
        fetchCount();
    }, []);

    return (
        <Col md="6" lg="4" className="box-col-4">
            <Card className="profit-card" >
                <CardHeader>
                    <div className="d-flex justify-content-between">
                        <div className="flex-grow-1">
                            <P attrPara={{ className: "square-after f-w-600 header-text-primary" }}>Total Parikramavasi's
                                <i className="fa fa-circle"></i>
                            </P>
                            <H4>{count}</H4>
                        </div>
                    </div>
                </CardHeader>
                <TotalParikamiCardBody />
            </Card>
        </Col >
    );
};

export default TotalParikami;